import React from "react";
import { useTranslation } from "react-i18next";

interface Props {
	description?: string;
}

const SubscriptionBasedRestrictionModalPlanHeaderInfoCard = ({ description }: Props) => {
	const { t } = useTranslation();

	return (
		<div className="d-flex align-items-center text-center flex-column mb-3">
			<h5 className={`${description ? "mb-2" : "mb-0"}`}>
				{t("lib:go_core.subscription_based_restriction.plan_pro.title")}
			</h5>
			{description && (
				<>
					<p className="text-muted mb-0">{description}</p>
					<a href="#">{t("lib:go_core.subscription_based_restriction.learn_more.title")}</a>
				</>
			)}
		</div>
	);
};

export default SubscriptionBasedRestrictionModalPlanHeaderInfoCard;
